export default function _onThisPage() {
    const pageBodyClass = '.page-layout__body';
    const pageBodyComponent = document.querySelector(pageBodyClass);
    // const pageBody = document.querySelector('.page-body');
    // const h3Titles = Array.from(pageBody.querySelectorAll('h2'));
    const componentContainer = document.querySelector(
        `[data-component="on-this-page"]`
    );

    if (!componentContainer) return;

    class OnThisPage {
        constructor({ component, wrapperClass }) {
            this.component =
                component instanceof HTMLElement
                    ? component
                    : document.querySelector(component);
            this.titleType = component.dataset.titleType;
            this.wrapperClass = wrapperClass;
        }

        /**
         * need to identify all titles on page within the page-layout__body
         *
         * whilst still retaining their order on the page for the navigation generation
         *
         * @return {array}
         */
        _identifyAndGetTitles() {
            if (pageBodyComponent) {
                ['h2', 'h3'].forEach((headingLevel) => {
                    pageBodyComponent
                        .querySelectorAll(headingLevel)
                        .forEach((title) => {
                            // eslint-disable-next-line no-param-reassign
                            title.dataset.onThisPage = 'true';
                        });
                });
            }

            return this._getTitles();
        }

        /**
         * gets all page titles of a certain type except for the current component's title
         *
         * each title is given an id that is inherited from the title's textContent
         *
         * @return {array}
         */
        _getTitles() {
            const titles = Array.from(
                // document.querySelectorAll(this.titleType)
                document.querySelectorAll('[data-on-this-page=true]')
            );

            if (!titles.length) return [];

            const { component } = this;
            const componentTitle = component.querySelector(this.titleType);
            const filteredTitles = titles.filter((title) =>
                title !== componentTitle ? title : ''
            );

            filteredTitles.forEach((title) => {
                if (title.id) return;

                const idTitle = title.textContent
                    .replace(/ /gi, '-')
                    .replace(
                        /!|@|#|\$|%|\^|&|\*|;|:|<|>|,|\.|\?|'|"|\[|\]|\(|\)/gi,
                        ''
                    )
                    .toLowerCase();

                title.setAttribute('id', `_${idTitle}`);
            });

            return filteredTitles;
        }

        /**
         * creates <a> elements with the id that corresponds to the specified page
         * title's id set in _getTitles()
         *
         * @param {array} titles
         * all the titles gathered from _getTitles()
         *
         * @return {array}
         */
        _getAnchors(titles) {
            const anchorList = [];

            titles.forEach((title) => {
                const id = title.getAttribute('id');
                const text = title.textContent;
                const anchor = document.createElement('a');

                anchor.setAttribute('href', `#${id}`);
                anchor.textContent = text;

                // anchor.addEventListener('click', this._scrollTo.bind(this));

                anchorList.push(anchor);
            });

            return anchorList;
        }

        /**
         * scrolls to the section of the page where the title is
         *
         * @return {void}
         */
        // _scrollTo(e) {
        // e.preventDefault();

        // const { target } = e;
        // const id = target.getAttribute('href');
        // const section = document.querySelector(id);

        // section.scrollIntoView({
        //     behavior: 'smooth',
        // });

        // }

        /**
         * renders out the HTML for the anchor links and their container
         *
         * @param {array} anchors
         * all the anchor tags generated from the _getAnchors() method
         *
         * @return {void}
         */
        _render(anchors) {
            const unordered = document.createElement('ul');
            const wrapper = document.createElement('div');

            wrapper.setAttribute('class', this.wrapperClass);

            anchors.forEach((anchor) => {
                const listItem = document.createElement('li');

                listItem.append(anchor);

                unordered.append(listItem);
            });

            wrapper.append(unordered);

            this.component.append(wrapper);
        }

        /**
         * initializes the build process
         *
         * @return {void}
         */
        init() {
            const titles = this._identifyAndGetTitles();

            // const titles = this._getTitles();

            if (!titles.length) return;

            const anchors = this._getAnchors(titles);

            this._render(anchors);
        }
    }

    const onThisPage = new OnThisPage({
        component: componentContainer,
        titleType: 'h2',
        wrapperClass: 'on-this-page__anchor-list',
    });

    onThisPage.init();
}

document.addEventListener('DOMContentLoaded', () => {
    _onThisPage();
});
